export const ChevronsLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.2651 9.7384L5.0177 15.9999L11.2582 22.2616" stroke="currentColor" stroke-width="2"/>
<path d="M19.7584 9.7384L13.511 15.9999L19.7515 22.2616" stroke="currentColor" stroke-width="2"/>
</svg>`;
